export default __webpack_public_path__ + "static/media/ketochickennuggets@2x.220e703f.jpg";